import { LACQUESIS_FEATURE_FLAG } from 'Constants/constants';
import { getSiteCode } from 'Selectors/config';
import store from '../app/store';

export const CHOOSE_PACKAGE_LAQUESIS_FEATURE_FLAG = LACQUESIS_FEATURE_FLAG.CHOOSE_PACKAGE?.[getSiteCode(store.getState())] || '';
